import {mapCapability} from './hardware.mapper';

export const HardwareMapper = {mapCapability};
